<ng-container *t="let t">
    <div class="apps-pane">
        <div class="nav" *ngIf="supplierCode">
            <button
                class="app-group"
                *ngFor="let tab of tabList;"
                [class.selected]="tab === currentTab"
                tslTooltip="{{ translate.get(tab) }}"
                [routerLink]="tab"
                (click)="currentTab = tab"
            >
                <div class="app-name">
                    {{ translate.get(tab) }}
                </div>
            </button>
        </div>
    </div>
</ng-container>